import { render, staticRenderFns } from "./pi1-person-distribution.vue?vue&type=template&id=9bdf102c"
import script from "./pi1-person-distribution.vue?vue&type=script&lang=js"
export * from "./pi1-person-distribution.vue?vue&type=script&lang=js"
import style0 from "./pi1-person-distribution.vue?vue&type=style&index=0&id=9bdf102c&prod&lang=less&rel=stylesheet%2Fless"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports